export const FORM_DUMP_FORMAT = 'lk-form-dump';
export const FORM_DUMP_VERSION = 1;

export function buildFormDump({ formSchema, formUiSchema, formInitialData }) {
  return {
    format: FORM_DUMP_FORMAT,
    version: FORM_DUMP_VERSION,
    form_schema: formSchema,
    form_ui_schema: formUiSchema,
    form_initial_data: isPlainObject(formInitialData) ? formInitialData : {},
  };
}

export function formDumpFileName(formCode) {
  return `${formCode}-dump.json`;
}

export function downloadFormDump(formCode, dump) {
  const blob = new Blob([JSON.stringify(dump, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = formDumpFileName(formCode);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function parseFormDump(text) {
  let data;
  try {
    data = JSON.parse(text);
  } catch (error) {
    return { ok: false, errors: ['Файл не является корректным JSON'] };
  }

  if (!isPlainObject(data)) {
    return { ok: false, errors: ['Дамп формы должен быть объектом'] };
  }

  const errors = [];
  if (data.format !== FORM_DUMP_FORMAT) {
    errors.push('Неверный формат дампа формы');
  }
  if (data.version !== FORM_DUMP_VERSION) {
    errors.push('Неподдерживаемая версия дампа формы');
  }

  const formSchema = data.form_schema;
  if (
    !isPlainObject(formSchema)
    || formSchema.type !== 'object'
    || !isPlainObject(formSchema.properties)
  ) {
    errors.push('form_schema должен быть объектом с type "object" и словарём properties');
  }

  const formUiSchema = data.form_ui_schema;
  if (!isPlainObject(formUiSchema) || !formUiSchema.type || !Array.isArray(formUiSchema.elements)) {
    errors.push('form_ui_schema должен быть объектом с type и массивом elements');
  }

  if (!isPlainObject(data.form_initial_data)) {
    errors.push('form_initial_data должен быть объектом');
  }

  if (errors.length > 0) {
    return { ok: false, errors };
  }

  return { ok: true, dump: data };
}
